import { render, staticRenderFns } from "./PlatformGateway.vue?vue&type=template&id=b3fc095e"
import script from "./PlatformGateway.vue?vue&type=script&lang=js"
export * from "./PlatformGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports